import { gql } from "@apollo/client";

export const GET_EQUIPMENT_DATA = gql`
  query Payment_getEquipmentData($equipmentId: String!, $companyUuid: String) {
    payment_getEquipmentData(
      equipmentID: $equipmentId
      companyUUID: $companyUuid
    ) {
      equipmentID
      orderID
      orderSum
      orderDescription
      orderUrl
      unix
    }
  }
`;
